import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import manageRoleApi from "../../../feature-module/crm/manageRoles/api/manageRoleApi";
import api from "../../../utils/api";
import {
  getCompanyNameArr,
  getProductCategoryAndNamesArr,
  getRoleNameArr,
} from "../../../utils/helpers/getDataArray";
import CompanyApi from "../../../feature-module/crm/companies/api/CompanyApi";
import ProductApi from "../../../feature-module/crm/products/api/productApi";
import { useLocation } from "react-router";
import { isSuperAdmin } from "../../../utils/helpers/helper";
import {
  resetFetchCompanyRoleState,
  setCompanyNameArray,
  setRoleNameArr,
} from "../../data/redux/authSlice";
import { scheduleReminderNotifications } from "../../../feature-module/crm/reminders/components/NotificationService";
import useReminders from "../../../feature-module/crm/reminders/hooks/useReminders";
import { setReloading } from "../../data/redux/moduleDataSlice";
import { setReloadAppInitializer } from "../../data/redux/commonSlice";

const AppInitializer = () => {
  const { reminders } = useReminders();
  const dispatch = useDispatch();
  const { fetchRoleData, fetchCompanyData } = useSelector(
    (state) => state.auth
  );
  const { reloadAppInitializer } = useSelector((state) => state.crms);

  useEffect(() => {
    const handleBeforeUnload = () => {
      // Detect reload event
      localStorage.setItem("reloading", "true");
    };

    // Attach event listener for browser reload
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    const reloading = localStorage.getItem("reloading");
    if (reloading) {
      // Update Redux state
      dispatch(setReloading(true));
      localStorage.removeItem("reloading");
    }
  }, [dispatch]);

  useEffect(() => {
    if (reminders?.length > 0) {
      scheduleReminderNotifications(reminders);
    }
  }, [reminders]);

  useEffect(() => {
    if (Notification.permission === "granted") {
      scheduleReminderNotifications();
    } else {
      Notification.requestPermission().then((permission) => {
        if (permission === "granted") {
          scheduleReminderNotifications();
        }
      });
    }
  }, []);

  // Function to fetch and store roles and company data
  const initializeAppData = async () => {
    try {
      // Check roles in localStorage
      if (fetchRoleData) {
        const rolesResponse = await manageRoleApi.fetchRoles();
        const roleNameArr = getRoleNameArr(rolesResponse?.data?.data);
        dispatch(setRoleNameArr(roleNameArr));
        localStorage.setItem("roleNameArr", JSON.stringify(roleNameArr));
      }

      // Check companies in localStorage
      if (fetchCompanyData || reloadAppInitializer) {
        const companiesResponse = await CompanyApi.fetchCompanies();
        const companyNameArr = getCompanyNameArr(companiesResponse?.data?.data);
        dispatch(setCompanyNameArray(companyNameArr));
        localStorage.setItem("companyNameArr", JSON.stringify(companyNameArr));
      }
    } catch (error) {
      console.error("Error initializing app data:", error);
    } finally {
      dispatch(resetFetchCompanyRoleState());
    }
  };

  useEffect(() => {
    // Initialize app data when the component mounts

    initializeAppData();
  }, [fetchRoleData, fetchCompanyData, reloadAppInitializer]);

  return null; // This component doesn't render anything
};

export default AppInitializer;
